<template>
    <div class="welfare-page-container v3" :class="isMedal && 'medal'">
        <!-- 抽奖区域 -->
        <div class="lottery-container">
            <div class="lottery-title"></div>
            <div v-if="isMedal" class="lottery-desc">
                <span class="desc-text">
                    勋章：
                    <span class="number">{{ medalNum }}</span>
                </span>
                <span class="desc-text right-margin">
                    金币数量：
                    <span class="number">{{ myCoin }}</span>
                </span>
            </div>
            <div v-else class="lottery-desc">
                <span class="desc-text">
                    我的金币
                    <span class="number">{{ myCoin }}</span>
                </span>
                <span class="desc-text">
                    <span class="number">100</span>
                    金币抽一次
                </span>
            </div>
            <lottery
                ref="lotteryRef"
                :prize-list="prizeList"
                :welfare-type="welfareType"
                @scrollToTaskList="scrollToTaskList"
            />
        </div>
        <!-- 任务列表 -->
        <div
            v-if="!isMedal"
            ref="taskContainer"
            class="task-container"
        >
            <div class="task-title"></div>
            <div class="task-sub-title">
                00:00 任务重置
            </div>
            <task :task-info="taskInfo"/>
        </div>

        <!-- 弹框 -->
        <dialog-box
            v-show="isShowDialogBox"
            ref="dialog"
            :dialog-num="dialogNum"
            :dialog-data="dialogData"
        />
    </div>
</template>

<script>
import Lottery from './Lottery.vue';
import Task from './Task.vue';
import {mapState} from 'vuex';
import Const from '../../../constant/Constant';
import StatisticConst from '@/pages/pano-game/constant/StatisticConst';
import DialogBox from '../../Main/components/Dialog/DialogBox';

export default {
    data() {
        return {
            conRef: null,
            dialogNum: 0,
            dialogData: {},
            isShowDialogBox: 0
        };
    },
    components: {
        DialogBox,
        Lottery,
        Task
    },
    computed: {
        ...mapState([
            'urlParams',
            'isLogin',
            'eventKey',
            'isMedal'
        ]),
        ...mapState('welfare', [
            'welfareData',
            'activityStatus',
            'myCoin',
            'medalNum',
            'myCash',
            'shareCode',
            'shareType',
            'kouLing',
            'taskInfo',
            'prizeList'
        ]),
        welfareType() {
            return this.isMedal ? Const.welfareType.medal : Const.welfareType.coin;
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.conRef = this.$refs.taskContainer;
        });
    },
    methods: {
        closeDialogBox() {
            this.isShowDialogBox = false;
            this.$refs.lotteryRef && this.$refs.lotteryRef.closeToast();
            this.$refs.dialog.stopScroll(false);
        },
        openDialog(typeNum, data) {
            this.dialogNum = typeNum;
            this.isShowDialogBox = true;
            this.dialogData = data;
            this.$refs.dialog.stopScroll(true);
            this.$refs.dialog.isShow = true;
        },
        scrollToTaskList() {
            this.$parent.scrollToTaskList();
        },
    }
};
</script>
<style lang='scss' scoped>

.welfare-page-container {
    width: 100%;
    min-height: 100vh;
    box-sizing: border-box;
    background-size: cover;
    background-position: top center;
    background-image: url('../../../assets/v2/welfare/bg.png');
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;

    .lottery-container {
        box-sizing: border-box;
        width: 100%;

        .lottery-title {
            width: 280px;
            height: 50px;
            margin-top: 92px;
            margin-left: 50%;
            transform: translateX(-50%);
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            background-image: url('../../../assets/v2/welfare/title.png');
        }

        .lottery-desc {
            width: 270px;
            height: 34px;
            margin-left: 50%;
            margin-top: 13px;
            transform: translateX(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 15px;
            background-size: 100% 100%;
            background-position: center;
            background-image: url('../../../assets/v2/welfare/subTitle.png');
            font-weight: 400;
            font-family: PingFang SC;
            color: #fff;
            text-shadow: 0 0 5px #62fbff;
        }
    }

    .task-container {
        box-sizing: border-box;
        width: 359px;
        height: 320px;
        margin-top: 35px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('../../../assets/v2/welfare/task-bg.png');
        overflow: hidden;

        .task-title {
            width: 210px;
            height: 29px;
            margin-top: 23px;
            margin-left: 50%;
            transform: translateX(-50%);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url('../../../assets/v2/welfare/task-title.png');
        }

        .task-sub-title {
            width: 303px;
            height: 20px;
            margin-top: 5px;
            margin-left: 50%;
            transform: translateX(-50%);
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url('../../../assets/v2/welfare/task-desc.png');
        }
    }

    &.v3 {
        background-color: #11157f;
        width: 375px;
        background-repeat: no-repeat;
        background-size: 100% 288px;
        background-position: center top;
        background-image: url('../../../assets/v3/welfare/welfareHeadBg.png');

        .lottery-container {
            padding-top: 140px;
            .lottery-title {
                display: none;
            }
            .lottery-desc {
                background-image: url('../../../assets/v3/welfare/lotteryTitleBg.png');
                display: flex;
                justify-content: space-around;
                align-items: center;
                .desc-text {
                    font-size: 14px;
                    font-family: PingFang-SC-Regular;
                    font-weight: 400;
                    color: #3BFFFC;
                    .number {
                        color: #FCFF22;
                    }
                    &:last-child {
                        margin-right: 10px;
                    }
                }
                .right-margin {
                    margin-right: -10px !important;
                }
            }
        }
        .task-container {
            background-color: #10157e;
            width: 375px;
            height: auto;
            background-repeat: no-repeat;
            background-size: 100% 71px;
            background-position: center top;
            background-image: url('../../../assets/v3/welfare/taskTitle.png');
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            .task-title {
                display: none;
            }
            .task-sub-title {
                width: auto;
                height: 20px;
                margin-top: 42px;
                background-image: none;
                font-size: 13px;
                font-family: PingFang-SC-Regular;
                font-weight: 400;
                color: #3BFFFC;
            }
        }

        &.medal {
            background-color: #000651;
            background-image: url('../../../assets/v4/welfare/welfareHeadBg.png');
        }
    }
}

</style>